import { injectable, interfaces } from 'inversify';
import { IObservableArray, makeObservable, observable } from 'mobx';
import { InputStatus } from '../../../../models/error.model';
import { IPagingInfoWithOrder, PaginationInfoDefault } from '../../../../models/paginationInfo.model';
import { allProjectActivities, IProjectActivity, ProjectActivity } from './projectDetailsActivities.models';

export interface IProjectDetailsActivitiesStore {
  projectActivities: IObservableArray<IProjectActivity<never>>;
  showLoader: boolean;
  projectActivitiesPaging: IPagingInfoWithOrder;
  selectedProjectActivities: IObservableArray<ProjectActivity>;
  activityLogStatus: InputStatus;
  setSelectedActivities(activities: ProjectActivity[]): void;
}

export namespace IProjectDetailsActivitiesStore {
  export const $: interfaces.ServiceIdentifier<IProjectDetailsActivitiesStore> = Symbol('PROJECT_DETAILS_ACTIVITIES_STORE');
}

@injectable()
export class ProjectDetailsActivitiesStore implements IProjectDetailsActivitiesStore {
  projectActivities: IObservableArray<IProjectActivity<never>> = observable.array([]);

  showLoader: boolean = false;

  selectedProjectActivities = observable.array([...allProjectActivities]);

  projectActivitiesPaging: IPagingInfoWithOrder = { ...PaginationInfoDefault, orderBy: 'createdDate', orderType: 'desc' };

  activityLogStatus: InputStatus = InputStatus.empty();

  constructor() {
    makeObservable(this, {
      projectActivities: observable.shallow,
      showLoader: observable,
      selectedProjectActivities: observable,
      projectActivitiesPaging: observable,
      activityLogStatus: observable,
    });
  }

  setSelectedActivities(activities: ProjectActivity[]): void {
    this.selectedProjectActivities.replace(activities);
  }
}
